export default "__VITE_PUBLIC_ASSET__228dd529__"